/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentLibraryService } from 'src/app/services/document-library.service';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-simple-text-input-dialog',
  templateUrl: './simple-text-input-dialog.component.html',
})
export class SimpleTextInputDialogComponent  {

  isPerformingAction = false;

  title: string;
  message: string;
  actionBtnText: string;
  declineBtnText: string;
  inputTextPlaceholder: string;
  isRequiredInput: boolean;
  acceptAction: (textInput: string) => Promise<void>;

  inputText: string = '';
  inputSuffix: string;

  constructor(private activeModal: NgbActiveModal, private documentLibraryService: DocumentLibraryService,
              private errorService: ErrorService) { }


  public onDecline(): void {
    this.activeModal.close(false);
  }

  public async onAccept(): Promise<void> {
    this.isPerformingAction = true;

    if(this.isRequiredInput && (this.inputText === undefined || this.inputText.length === 0)){
      this.errorService.show('Please, fill the field above', undefined);
      this.isPerformingAction = false;
      return;
    }


    if (this.acceptAction) {
      try {
        await this.acceptAction(this.inputText);
        this.activeModal.close(true);
      }
      catch(error) {
        this.errorService.show('Failed to perform the requested action', error);
        this.isPerformingAction = false;
        return;
      }
    }
    this.isPerformingAction = false;
    this.activeModal.close(true);
  }

  public onDismiss(): void {
    this.activeModal.close(false);
    this.activeModal.dismiss();
  }

  get isDisabledActionBtn(): boolean {
    return this.isPerformingAction || (this.isRequiredInput && this.inputText.length === 0);
  }
}
